import palette from '../../palette';

export default {
  daySelected: {
    backgroundColor: palette.blueMain,
    '&:hover': {
      backgroundColor: palette.blueMain
    },
  },
  current: {
    color: palette.greenMiddle,
  },
};
